<template>
  <div class="content">
    <div class="topDesc">
      <div class="left">{{
          progressColor === '1' ? $t('lang.inviteFriends.Lakh') : $t('lang.inviteFriends.subLakh')
        }}
      </div>
      <div class="right">{{ userInfo ? current : '0' }}</div>
    </div>
    <div class="line-box"
         @touchstart="handleTouchStart"
         @touchmove="handleTouchMove"
         @touchend="handleTouchEnd"
    >
      <div :class="'grayLine'+progressColor">
        <div class="colorLine" :style="{width:percent}"/>
      </div>
      <div :class="'degrees'+progressColor">
        <div class="relative">
          <div class="dc" v-show="colors.length>0&&colors[0].Status===0"/>
          <div :class="degrees[0]*1>current*1?'dx':'d0'"
               :style="(degrees[0]+'').length>=4?'font-size:2.84vw;letter-spacing: -0.1em;':''">{{ degrees[0] }}</div>
        </div>
        <div class="relative">
          <div class="dc" v-show="colors.length>0&&colors[1].Status===0"/>
          <div :class="degrees[1]*1>current*1?'dx':'d1'"
               :style="(degrees[1]+'').length>=4?'font-size:2.84vw;letter-spacing: -0.1em;':''">{{ degrees[1] }}</div>
        </div>
        <div class="relative">
          <div class="dc" v-show="colors.length>0&&colors[2].Status===0"/>
          <div :class="degrees[2]*1>current*1?'dx':'d2'"
               :style="(degrees[2]+'').length>=4?'font-size:2.84vw;letter-spacing: -0.1em;':''">{{ degrees[2] }}</div>
        </div>
        <div class="relative">
          <div class="dc" v-show="colors.length>0&&colors[3].Status===0"/>
          <div :class="degrees[3]*1>current*1?'dx':'d3'"
               :style="(degrees[3]+'').length>=4?'font-size:2.84vw;letter-spacing: -0.1em;':''">{{ degrees[3] }}</div>
        </div>
        <div class="relative">
          <div class="dc" v-show="colors.length>0&&colors[4].Status===0"/>
          <div :class="degrees[4]*1>current*1?'dx':'d4'"
               :style="(degrees[4]+'').length>=4?'font-size:2.84vw;letter-spacing: -0.1em;':''">{{ degrees[4] }}</div>
        </div>
        <div class="relative">
          <div class="dc" v-show="colors.length>0&&colors[5].Status===0"/>
          <div :class="degrees[5]*1>current*1?'dx':'d5'"
               :style="(degrees[5]+'').length>=4?'font-size:2.84vw;letter-spacing: -0.1em;':''">{{ degrees[5] }}
          </div>
        </div>
      </div>
      <div class="amounts" :style="{ color: progressColor === '1' ? '#A8F25C' : '#FAE362' }">
        <div :style="{ color: degrees[index]*1>current*1 ? '#A1A1A1' : '' }" v-for="(item,index) in amounts"
             :key="index">
          <span v-if="item">{{ $t('lang.account.currencyType') }}</span>{{
            item === 0 ? '' : item
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['current', 'progressColor', 'gifts'],
  data () {
    return {
      userInfo: localStorage.getItem('userInfo'),
      touchDirection: null,
      percent: '0%',
      levels: [],
      rewards: [],
      degrees: [],
      amounts: [],
      colors: [],
      giftIndex: 0,
      giftRange: [0, 6]
    }
  },
  watch: {
    degrees () {
      this.decimalToPercent()
    },
    gifts (n, o) {
      this.colors = n.slice(this.giftRange[0], this.giftRange[1])
    }
  },
  mounted () {
    this.levels = []
    this.rewards = []
    this.gifts.forEach(e => {
      this.levels.push((e.BetAmount / 100000))
      this.rewards.push((e.RewardAmount))
    })
    this.colors = this.gifts.slice(this.giftRange[0], this.giftRange[1])
    this.degrees = this.levels.slice(this.giftRange[0], this.giftRange[1])
    this.amounts = this.rewards.slice(this.giftRange[0], this.giftRange[1])
    this.decimalToPercent()
  },
  methods: {
    handleTouchStart (event) {
      this.startX = event.touches[0].clientX
      this.startY = event.touches[0].clientY
      this.touchDirection = null
    },
    handleTouchMove (event) {
      const currentX = event.touches[0].clientX
      const currentY = event.touches[0].clientY
      const diffX = this.startX - currentX
      const diffY = this.startY - currentY

      // 判断是左右滑动还是上下滑动
      if (Math.abs(diffX) > Math.abs(diffY)) {
        // 左右滑动
        if (diffX > 0) {
          this.touchDirection = 'left'
        } else if (diffX < 0) {
          this.touchDirection = 'right'
        } else {
          this.touchDirection = null
        }
      } else {
        this.touchDirection = null
      }

      // 阻止默认滚动行为
      event.preventDefault()
    },
    handleTouchEnd () {
      if (this.touchDirection && this.touchDirection === 'left') {
        this.toRight()
      } else if (this.touchDirection && this.touchDirection === 'right') {
        this.toLeft()
      }
    },
    toRight () {
      if (this.giftRange[1] < this.gifts.length && this.gifts.length > 6) {
        this.giftIndex = this.giftIndex - 1
        this.giftRange[0] = this.giftRange[0] + 1
        this.giftRange[1] = this.giftRange[1] + 1
        this.colors = this.gifts.slice(this.giftRange[0], this.giftRange[1])
        this.degrees = this.levels.slice(this.giftRange[0], this.giftRange[1])
        this.amounts = this.rewards.slice(this.giftRange[0], this.giftRange[1])
      }
    },
    toLeft () {
      if (this.giftRange[0] > 0 && this.gifts.length > 6) {
        this.giftIndex = this.giftIndex + 1
        this.giftRange[0] = this.giftRange[0] - 1
        this.giftRange[1] = this.giftRange[1] - 1
        this.colors = this.gifts.slice(this.giftRange[0], this.giftRange[1])
        this.degrees = this.levels.slice(this.giftRange[0], this.giftRange[1])
        this.amounts = this.rewards.slice(this.giftRange[0], this.giftRange[1])
      }
      this.decimalToPercent()
    },
    // 小数转化百分比
    decimalToPercent () {
      this.percent = '0%'
      if (this.degrees && this.degrees.length > 0) {
        const start = this.degrees.find(e => e !== null && e !== undefined && e !== '')
        const end = this.degrees[this.degrees.length - 1]
        if (this.current >= start && this.current < end) {
          const index = this.insertPosition(this.current, this.degrees) - 1
          const a = Math.floor((0.2 * index) * 100)
          const val = this.current - this.degrees[index]
          const len = this.degrees[index + 1] - this.degrees[index]
          this.percent = Math.ceil((val / len) * 20 + a) + '%'
        } else if (this.current < start) {
          this.percent = '0%'
        } else if (this.current >= end) {
          this.percent = '100%'
        }
      }
    },
    insertPosition (percent, degrees) {
      for (let i = 0; i < degrees.length; i++) {
        if (percent < degrees[i]) {
          return i
        }
      }
      return degrees.length
    }
  }
}
</script>

<style scoped lang="less">
.content {
  position: relative;
  top: 0;
  width: 100%;
  height: max-content;

  .topDesc {
    position: relative;
    top: 3vw;
    left: 50%;
    transform: translate(-50%);
    width: 90%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      font-size: 3.476vw;
      font-weight: 500;
      color: #FFFFFF;
    }

    .right {
      font-size: 3.476vw;
      font-weight: 400;
      text-align: right;
      color: #A4A4A4;
    }
  }

  .line-box {
    position: relative;
    top: 7vw;
    left: 50%;
    transform: translate(-50%);
    display: flex;
    align-items: center;
    width: 74vw;
    height: 5.5vw;
    overflow: visible;

    .relative {
      position: relative;
    }

    .degrees1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      text-shadow: -0.5px -0.5px 1px #474747;

      div {
        width: 5.5vw;
        height: 5.5vw;
        line-height: 5.5vw;
        border-radius: 0.8vw;
        font-size: 3.12vw;
        font-weight: 700;
        text-align: center;
        letter-spacing: -0.1em;
        color: #000000;
      }

      .dc {
        position: absolute;
        top: -0.694vw;
        left: -0.694vw;
        bottom: -0.694vw;
        right: -0.694vw;
        width: 6.888vw;
        height: 6.888vw;
        border-radius: 1.111vw;
        animation: gradient 999ms infinite;
      }

      @keyframes gradient {
        0% {
          background: linear-gradient(220.83deg, #E71810 -4.29%, #E7BA1A 33.26%, #FFF500 47.49%, rgba(253, 255, 135, 0.3) 99.27%);
        }
        11% {
          background: linear-gradient(220.83deg, rgba(253, 255, 135, 0.3) 0%, #E71810 40%, #E7BA1A 52%, #FFF500 105%);
        }
        22% {
          background: linear-gradient(180deg, #E71810 -18.71%, #E7BA1A 34.33%, #FFF500 54.44%, rgba(253, 255, 135, 0.3) 127.58%);
        }
        33% {
          background: linear-gradient(135deg, #E71810 0%, #E7BA1A 36.26%, #FFF500 50%, rgba(253, 255, 135, 0.3) 100%);
        }
        44% {
          background: linear-gradient(90deg, #E71810 0%, #E7BA1A 39.76%, #FFF500 54.83%, rgba(253, 255, 135, 0.3) 109.65%);
        }
        55% {
          background: linear-gradient(45deg, #E71810 0%, #E7BA1A 36.26%, #FFF500 50%, rgba(253, 255, 135, 0.3) 100%);
        }
        66% {
          background: linear-gradient(0deg, #E71810 -12.93%, #E7BA1A 28.01%, #FFF500 43.53%, rgba(253, 255, 135, 0.3) 100%);
        }
        77% {
          background: linear-gradient(315deg, #E71810 0%, #E7BA1A 36.26%, #FFF500 50%, rgba(253, 255, 135, 0.3) 100%);
        }
        88% {
          background: linear-gradient(270deg, #E71810 0%, #E7BA1A 36.26%, #FFF500 50%, rgba(253, 255, 135, 0.3) 100%);
        }
        100% {
          background: linear-gradient(227.13deg, #E71810 0%, #E7BA1A 37.71%, #FFF500 52%, rgba(253, 255, 135, 0.3) 104.01%);
        }
      }

      .dx {
        position: relative;
        text-shadow: none;
        color: #80847E;
        background: #32382E;
      }

      .d0 {
        position: relative;
        background: linear-gradient(138.12deg, #B2E90F -25.75%, #B9ED1F 182.32%);
      }

      .d1 {
        position: relative;
        background: linear-gradient(136.64deg, #9BE423 -9.23%, #79DA28 150.13%);
      }

      .d2 {
        position: relative;
        background: linear-gradient(90deg, #5DD22C -80.92%, #61D829 169.47%);
      }

      .d3 {
        position: relative;
        background: linear-gradient(90deg, #7BDC3F -80.92%, #50D024 169.47%);
      }

      .d4 {
        position: relative;
        background: linear-gradient(90deg, #59D13C -80.92%, #29C022 169.47%);
      }

      .d5 {
        position: relative;
        background: linear-gradient(90deg, #33C538 -80.92%, #00C620 169.47%);
      }
    }

    .degrees2 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      text-shadow: -0.5px -0.5px 1px #474747;

      div {
        width: 5.5vw;
        height: 5.5vw;
        line-height: 5.5vw;
        border-radius: 0.8vw;
        font-size: 3.12vw;
        font-weight: 700;
        text-align: center;
        letter-spacing: -0.1em;
        color: #000000;
      }

      .dc {
        position: absolute;
        top: -0.694vw;
        left: -0.694vw;
        bottom: -0.694vw;
        right: -0.694vw;
        width: 6.888vw;
        height: 6.888vw;
        border-radius: 1.111vw;
        animation: gradient2 999ms infinite;
      }

      @keyframes gradient2 {
        0% {
          background: linear-gradient(220.83deg, #61FF71 -4.29%, #D4C2D4 33.26%, #EA9DF8 47.49%, rgba(97, 255, 113, 0.5) 99.27%);
        }
        11% {
          background: linear-gradient(220.83deg, rgba(234, 157, 248, 0.5) 0%, #61FF71 40%, #D4C2D4 52%, #EA9DF8 105%);
        }
        22% {
          background: linear-gradient(180deg, #61FF71 -18.71%, #D4C2D4 34.33%, #EA9DF8 54.44%, rgba(234, 157, 248, 0.5) 127.58%);
        }
        33% {
          background: linear-gradient(135deg, #61FF71 0%, #D4C2D4 36.26%, #EA9DF8 50%, rgba(234, 157, 248, 0.5) 100%);
        }
        44% {
          background: linear-gradient(90deg, #61FF71 0%, #D4C2D4 39.76%, #EA9DF8 54.83%, rgba(234, 157, 248, 0.5) 109.65%);
        }
        55% {
          background: linear-gradient(45deg, #61FF71 0%, #D4C2D4 36.26%, #EA9DF8 50%, rgba(234, 157, 248, 0.5) 100%);
        }
        66% {
          background: linear-gradient(0deg, #61FF71 -12.93%, #D4C2D4 28.01%, #EA9DF8 43.53%, rgba(234, 157, 248, 0.5) 100%);
        }
        77% {
          background: linear-gradient(315deg, #61FF71 0%, #D4C2D4 36.26%, #EA9DF8 50%, rgba(234, 157, 248, 0.5) 100%);
        }
        88% {
          background: linear-gradient(270deg, #61FF71 0%, #D4C2D4 36.26%, #EA9DF8 50%, rgba(234, 157, 248, 0.5) 100%);
        }
        100% {
          background: linear-gradient(227.13deg, #61FF71 0%, #D4C2D4 37.71%, #EA9DF8 52%, rgba(234, 157, 248, 0.5) 104.01%);
        }
      }

      .dx {
        position: relative;
        text-shadow: none;
        color: #555754;
        background: radial-gradient(50% 50% at 50% 50%, #1B1B1B 0%, #11150F 100%);
      }

      .d0 {
        position: relative;
        background: linear-gradient(152.32deg, #FFF59A 9.94%, #F0E36E 106.41%);
      }

      .d1 {
        position: relative;
        background: linear-gradient(141.71deg, #FFF59B -10.64%, #F8EB70 137.5%);
      }

      .d2 {
        position: relative;
        background: linear-gradient(139.4deg, #FAEF8A -2.54%, #FFEC42 138.83%);
      }

      .d3 {
        position: relative;
        background: linear-gradient(139.4deg, #F9ED6C -2.54%, #FFF23B 138.83%);
      }

      .d4 {
        position: relative;
        background: linear-gradient(139.4deg, #FBF03F -2.54%, #FDF425 138.83%);
      }

      .d5 {
        position: relative;
        background: linear-gradient(139.4deg, #FEF314 -2.54%, #FED915 138.83%);
      }
    }

    .grayLine1 {
      margin: 0 auto;
      height: 1vw;
      width: 90%;
      background: #32382E;

      .colorLine {
        height: 1vw;
        background: linear-gradient(269.98deg, #1CBE36 -6.42%, #E6FF4A 100.13%);
        box-shadow: 0px 0px 0.4vw 0.4vw rgba(255, 255, 255, 0.2);
      }
    }

    .grayLine2 {
      margin: 0 auto;
      height: 1vw;
      width: 90%;
      background: linear-gradient(270deg, #121212 -1.37%, #181818 103.42%);

      .colorLine {
        height: 1vw;
        background: linear-gradient(269.97deg, #FFF500 -2.19%, #F8EC7C 52.04%, #FFF7AA 100.14%);
        box-shadow: 0px 0px 0.4vw 0.4vw rgba(255, 255, 255, 0.2);
      }
    }

    .amounts {
      position: absolute;
      top: 7vw;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      line-height: 5.5vw;
      border-radius: 0.8vw;
      font-size: 3.27vw;
      font-weight: 400;

      div {
        text-align: right;
        width: 5.5vw;
        display: flex;
        justify-content: center;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ProgressLine/progressInvite.vue